export enum ReferralAuthorizationStatus {
  Active = 'active',
  Expired = 'expired',
  NotStarted = 'not_started',
  Canceled = 'canceled'
}

export class ReferralAuthorization {
  authNumber: string;
  therapyType: string;
  startDate: string;
  expirationDate: string;
  status: ReferralAuthorizationStatus;

  load_from_json(json: any): ReferralAuthorization {
    this.authNumber = json.authNumber;
    this.therapyType = json.therapyType;
    this.startDate = json.startDate;
    this.expirationDate = json.expirationDate;
    this.status = json.status;

    return this;
  }
}
